module.exports = __webpack_public_path__ + "icon.01b6bc9d9c22960e7a7c.ttf";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/icon.ttf
// module id = ../../../../../www/assets/fonts/icon.ttf
// module chunks = styles